var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recipe-by"},[_c('span',[_vm._v("Recipe By: ")]),(_vm.sourceUrl)?_c('a',{attrs:{"href":_vm.sourceUrl,"target":"_blank"}},[_c('em',[_vm._v(_vm._s(_vm.name))])]):_c('em',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }